import { render } from "./baseTemplate.vue?vue&type=template&id=72252e97"
import script from "./baseTemplate.vue?vue&type=script&lang=js"
export * from "./baseTemplate.vue?vue&type=script&lang=js"

import "./baseTemplate.vue?vue&type=style&index=0&id=72252e97&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__